import { Box } from "@mui/material";

import { useNavbar, ViewNameTranslation } from "~/hooks/useNavbar";

import { GridView } from "./components/GridView";

const VIEW_TITLE: ViewNameTranslation = "nav.viewname.settings grid view";

export function GridViewPage() {
  useNavbar({ viewTitle: VIEW_TITLE });

  return (
    <Box sx={{ p: 3, width: "100%", maxWidth: "unset" }}>
      <GridView />
    </Box>
  );
}
